import React, { useState, useEffect, useRef } from 'react'

export function GoalDropdown({
  selectedGoalId,
  activeGoals,
  allowClear = true,
  onSelect,
  disabled = false,
  triggerStyle = {},
  triggerLabel,
}) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    const handleKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [open])

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => !disabled && setOpen(!open)}
        disabled={disabled}
        style={triggerStyle}
        aria-label={
          selectedGoalId
            ? `Linked to goal: ${triggerLabel}. Click to change.`
            : 'Link to goal'
        }
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {triggerLabel}
      </button>

      {open && (
        <div role="menu" style={dropdownStyles.menu}>
          {activeGoals.map((goal) => (
            <button
              key={goal.goalId}
              role="menuitem"
              onClick={() => { onSelect(goal.goalId); setOpen(false) }}
              style={{
                ...dropdownStyles.item,
                background: goal.goalId === selectedGoalId ? '#EAF3DE' : 'transparent',
              }}
            >
              {goal.title}
            </button>
          ))}
          {allowClear && (
            <>
              <div style={dropdownStyles.divider} />
              <button
                role="menuitem"
                onClick={() => { onSelect(null); setOpen(false) }}
                style={{
                  ...dropdownStyles.item,
                  color: '#5F5E5A',
                  background: selectedGoalId == null ? '#f1efe8' : 'transparent',
                }}
              >
                no goal
              </button>
            </>
          )}
        </div>
      )}
    </div>
  )
}

const dropdownStyles = {
  menu: {
    position: 'absolute',
    top: '100%',
    left: 0,
    marginTop: 4,
    background: 'white',
    border: '0.5px solid #e8e6de',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    padding: 4,
    minWidth: 200,
    maxWidth: 280,
    zIndex: 10,
  },
  item: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '6px 10px',
    border: 'none',
    borderRadius: 4,
    fontSize: 12,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    background: 'transparent',
    fontFamily: 'inherit',
  },
  divider: {
    borderTop: '0.5px solid #e8e6de',
    margin: '4px 0',
  },
}
